// ============ CLIENTS ============
export const CLIENT_TYPES = {
  INDIVIDUAL: "individual",
  CORPORATE: "corporate",
  WEDDING: "wedding",
};

export const CLIENT_STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  ARCHIVED: "archived",
};

export const CLIENT_STAGES = {
  LEAD: "lead",
  ENQUIRY: "enquiry",
  PROPOSAL: "proposal",
  BOOKED: "booked",
  ACTIVE_CLIENT: "active_client",
  REPEAT_CLIENT: "repeat_client",
  LOST: "lost",
};

// ============ LEADS ============
export const LEAD_TYPES = {
  WEDDING: "wedding",
  PORTRAIT: "portrait",
  EVENT: "event",
  COMMERCIAL: "commercial",
  MATERNITY: "maternity",
};

export const LEAD_STATUS = {
  NEW: "new",
  CONTACTED: "contacted",
  QUALIFIED: "qualified",
  PROPOSAL_SENT: "proposal_sent",
  WON: "won",
  LOST: "lost",
};

export const LEAD_PRIORITY = {
  HIGH: "high",
  MEDIUM: "medium",
  LOW: "low",
};

export const LEAD_TEMPERATURE = {
  HOT: "hot",
  WARM: "warm",
  COLD: "cold",
};

// ============ PROJECTS ============
export const PROJECT_TYPES = {
  WEDDING: "wedding",
  PORTRAIT: "portrait",
  EVENT: "event",
  COMMERCIAL: "commercial",
  MATERNITY: "maternity",
};

export const PROJECT_STATUS = {
  ENQUIRY: "enquiry",
  PLANNING: "planning",
  ACTIVE: "active",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
};

export const PROJECT_STAGES = {
  PRE_PRODUCTION: "pre_production",
  SHOOT_DAY: "shoot_day",
  EDITING: "editing",
  GALLERY_DELIVERY: "gallery_delivery",
  ALBUM_DESIGN: "album_design",
  FINAL_DELIVERY: "final_delivery",
  CLOSED: "closed",
};

// ============ QUOTATIONS ============
export const QUOTATION_STATUS = {
  DRAFT: "draft",
  SENT: "sent",
  VIEWED: "viewed",
  ACCEPTED: "accepted",
  REJECTED: "rejected",
  EXPIRED: "expired",
};

// ============ CONTRACTS ============
export const CONTRACT_STATUS = {
  DRAFT: "draft",
  SENT: "sent",
  SIGNED: "signed",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
};

// ============ INVOICES ============
export const INVOICE_STATUS = {
  DRAFT: "draft",
  SENT: "sent",
  VIEWED: "viewed",
  PARTIALLY_PAID: "partially_paid",
  PAID: "paid",
  OVERDUE: "overdue",
  CANCELLED: "cancelled",
};

// ============ PAYMENTS ============
export const PAYMENT_STATUS = {
  PENDING: "pending",
  COMPLETED: "completed",
  FAILED: "failed",
  REFUNDED: "refunded",
};

export const PAYMENT_METHODS = {
  CASH: "cash",
  CARD: "card",
  BANK_TRANSFER: "bank_transfer",
  UPI: "upi",
  CHEQUE: "cheque",
};

// ============ TASKS ============
export const TASK_TYPES = {
  FOLLOW_UP: "follow_up",
  DELIVERABLE: "deliverable",
  REMINDER: "reminder",
  GENERAL: "general",
};

export const TASK_PRIORITY = {
  HIGH: "high",
  MEDIUM: "medium",
  LOW: "low",
};

export const TASK_STATUS = {
  PENDING: "pending",
  IN_PROGRESS: "in_progress",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
};

// ============ APPOINTMENTS ============
export const APPOINTMENT_TYPES = {
  CONSULTATION: "consultation",
  SHOOT: "shoot",
  MEETING: "meeting",
  CALL: "call",
  VIDEO_CALL: "video_call",
};

export const APPOINTMENT_STATUS = {
  SCHEDULED: "scheduled",
  CONFIRMED: "confirmed",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
  NO_SHOW: "no_show",
};

// ============ INTERACTIONS ============
export const INTERACTION_TYPES = {
  MEETING: "meeting",
  CALL: "call",
  EMAIL: "email",
  WHATSAPP: "whatsapp",
  SMS: "sms",
  WEBSITE_FORM: "website_form",
  INSTAGRAM: "instagram",
  OTHER: "other",
};

export const INTERACTION_DIRECTION = {
  INCOMING: "incoming",
  OUTGOING: "outgoing",
};

// ============ FEEDBACK ============
export const FEEDBACK_CATEGORY = {
  PHOTOGRAPHY: "photography",
  VIDEOGRAPHY: "videography",
  SERVICE: "service",
  DELIVERY: "delivery",
  OVERALL: "overall",
};

// ============ OPTIONS ============
export const CLIENT_TYPE_OPTIONS = [
  { value: CLIENT_TYPES.INDIVIDUAL, label: "Individual" },
  { value: CLIENT_TYPES.CORPORATE, label: "Corporate" },
  { value: CLIENT_TYPES.WEDDING, label: "Wedding" },
];

export const CLIENT_STATUS_OPTIONS = [
  { value: CLIENT_STATUS.ACTIVE, label: "Active" },
  { value: CLIENT_STATUS.INACTIVE, label: "Inactive" },
  { value: CLIENT_STATUS.ARCHIVED, label: "Archived" },
];

export const CLIENT_STAGE_OPTIONS = [
  { value: CLIENT_STAGES.LEAD, label: "Lead" },
  { value: CLIENT_STAGES.ENQUIRY, label: "Enquiry" },
  { value: CLIENT_STAGES.PROPOSAL, label: "Proposal" },
  { value: CLIENT_STAGES.BOOKED, label: "Booked" },
  { value: CLIENT_STAGES.ACTIVE_CLIENT, label: "Active Client" },
  { value: CLIENT_STAGES.REPEAT_CLIENT, label: "Repeat Client" },
  { value: CLIENT_STAGES.LOST, label: "Lost" },
];

export const LEAD_TYPE_OPTIONS = [
  { value: LEAD_TYPES.WEDDING, label: "Wedding" },
  { value: LEAD_TYPES.PORTRAIT, label: "Portrait" },
  { value: LEAD_TYPES.EVENT, label: "Event" },
  { value: LEAD_TYPES.COMMERCIAL, label: "Commercial" },
  { value: LEAD_TYPES.MATERNITY, label: "Maternity" },
];

export const LEAD_STATUS_OPTIONS = [
  { value: LEAD_STATUS.NEW, label: "New" },
  { value: LEAD_STATUS.CONTACTED, label: "Contacted" },
  { value: LEAD_STATUS.QUALIFIED, label: "Qualified" },
  { value: LEAD_STATUS.PROPOSAL_SENT, label: "Proposal Sent" },
  { value: LEAD_STATUS.WON, label: "Won" },
  { value: LEAD_STATUS.LOST, label: "Lost" },
];

export const LEAD_PRIORITY_OPTIONS = [
  { value: LEAD_PRIORITY.HIGH, label: "High" },
  { value: LEAD_PRIORITY.MEDIUM, label: "Medium" },
  { value: LEAD_PRIORITY.LOW, label: "Low" },
];

export const LEAD_TEMPERATURE_OPTIONS = [
  { value: LEAD_TEMPERATURE.HOT, label: "🔥 Hot" },
  { value: LEAD_TEMPERATURE.WARM, label: "🌤️ Warm" },
  { value: LEAD_TEMPERATURE.COLD, label: "❄️ Cold" },
];

export const PROJECT_TYPE_OPTIONS = [
  { value: PROJECT_TYPES.WEDDING, label: "Wedding" },
  { value: PROJECT_TYPES.PORTRAIT, label: "Portrait" },
  { value: PROJECT_TYPES.EVENT, label: "Event" },
  { value: PROJECT_TYPES.COMMERCIAL, label: "Commercial" },
  { value: PROJECT_TYPES.MATERNITY, label: "Maternity" },
];

export const PROJECT_STATUS_OPTIONS = [
  { value: PROJECT_STATUS.ENQUIRY, label: "Enquiry" },
  { value: PROJECT_STATUS.PLANNING, label: "Planning" },
  { value: PROJECT_STATUS.ACTIVE, label: "Active" },
  { value: PROJECT_STATUS.COMPLETED, label: "Completed" },
  { value: PROJECT_STATUS.CANCELLED, label: "Cancelled" },
];

export const PROJECT_STAGE_OPTIONS = [
  { value: PROJECT_STAGES.PRE_PRODUCTION, label: "Pre-Production" },
  { value: PROJECT_STAGES.SHOOT_DAY, label: "Shoot Day" },
  { value: PROJECT_STAGES.EDITING, label: "Editing" },
  { value: PROJECT_STAGES.GALLERY_DELIVERY, label: "Gallery Delivery" },
  { value: PROJECT_STAGES.ALBUM_DESIGN, label: "Album Design" },
  { value: PROJECT_STAGES.FINAL_DELIVERY, label: "Final Delivery" },
  { value: PROJECT_STAGES.CLOSED, label: "Closed" },
];

export const TASK_STATUS_OPTIONS = [
  { value: TASK_STATUS.PENDING, label: "Pending" },
  { value: TASK_STATUS.IN_PROGRESS, label: "In Progress" },
  { value: TASK_STATUS.COMPLETED, label: "Completed" },
  { value: TASK_STATUS.CANCELLED, label: "Cancelled" },
];

export const TASK_PRIORITY_OPTIONS = [
  { value: TASK_PRIORITY.HIGH, label: "High" },
  { value: TASK_PRIORITY.MEDIUM, label: "Medium" },
  { value: TASK_PRIORITY.LOW, label: "Low" },
];

export const PAYMENT_STATUS_OPTIONS = [
  { value: PAYMENT_STATUS.PENDING, label: "Pending" },
  { value: PAYMENT_STATUS.COMPLETED, label: "Completed" },
  { value: PAYMENT_STATUS.FAILED, label: "Failed" },
  { value: PAYMENT_STATUS.REFUNDED, label: "Refunded" },
];

export const PAYMENT_METHOD_OPTIONS = [
  { value: PAYMENT_METHODS.CASH, label: "Cash" },
  { value: PAYMENT_METHODS.CARD, label: "Card" },
  { value: PAYMENT_METHODS.BANK_TRANSFER, label: "Bank Transfer" },
  { value: PAYMENT_METHODS.UPI, label: "UPI" },
  { value: PAYMENT_METHODS.CHEQUE, label: "Cheque" },
];

export const INVOICE_STATUS_OPTIONS = [
  { value: INVOICE_STATUS.DRAFT, label: "Draft" },
  { value: INVOICE_STATUS.SENT, label: "Sent" },
  { value: INVOICE_STATUS.VIEWED, label: "Viewed" },
  { value: INVOICE_STATUS.PARTIALLY_PAID, label: "Partially Paid" },
  { value: INVOICE_STATUS.PAID, label: "Paid" },
  { value: INVOICE_STATUS.OVERDUE, label: "Overdue" },
  { value: INVOICE_STATUS.CANCELLED, label: "Cancelled" },
];

export const CONTRACT_STATUS_OPTIONS = [
  { value: CONTRACT_STATUS.DRAFT, label: "Draft" },
  { value: CONTRACT_STATUS.SENT, label: "Sent" },
  { value: CONTRACT_STATUS.SIGNED, label: "Signed" },
  { value: CONTRACT_STATUS.COMPLETED, label: "Completed" },
  { value: CONTRACT_STATUS.CANCELLED, label: "Cancelled" },
];

export const QUOTATION_STATUS_OPTIONS = [
  { value: QUOTATION_STATUS.DRAFT, label: "Draft" },
  { value: QUOTATION_STATUS.SENT, label: "Sent" },
  { value: QUOTATION_STATUS.VIEWED, label: "Viewed" },
  { value: QUOTATION_STATUS.ACCEPTED, label: "Accepted" },
  { value: QUOTATION_STATUS.REJECTED, label: "Rejected" },
  { value: QUOTATION_STATUS.EXPIRED, label: "Expired" },
];

export const APPOINTMENT_STATUS_OPTIONS = [
  { value: APPOINTMENT_STATUS.SCHEDULED, label: "Scheduled" },
  { value: APPOINTMENT_STATUS.CONFIRMED, label: "Confirmed" },
  { value: APPOINTMENT_STATUS.COMPLETED, label: "Completed" },
  { value: APPOINTMENT_STATUS.CANCELLED, label: "Cancelled" },
  { value: APPOINTMENT_STATUS.NO_SHOW, label: "No Show" },
];

export const APPOINTMENT_TYPE_OPTIONS = [
  { value: APPOINTMENT_TYPES.CONSULTATION, label: "Consultation" },
  { value: APPOINTMENT_TYPES.SHOOT, label: "Shoot" },
  { value: APPOINTMENT_TYPES.MEETING, label: "Meeting" },
  { value: APPOINTMENT_TYPES.CALL, label: "Call" },
  { value: APPOINTMENT_TYPES.VIDEO_CALL, label: "Video Call" },
];

export const INTERACTION_TYPE_OPTIONS = [
  { value: INTERACTION_TYPES.MEETING, label: "Meeting" },
  { value: INTERACTION_TYPES.CALL, label: "Call" },
  { value: INTERACTION_TYPES.EMAIL, label: "Email" },
  { value: INTERACTION_TYPES.WHATSAPP, label: "WhatsApp" },
  { value: INTERACTION_TYPES.SMS, label: "SMS" },
  { value: INTERACTION_TYPES.WEBSITE_FORM, label: "Website Form" },
  { value: INTERACTION_TYPES.INSTAGRAM, label: "Instagram" },
  { value: INTERACTION_TYPES.OTHER, label: "Other" },
];

export const INTERACTION_DIRECTION_OPTIONS = [
  { value: INTERACTION_DIRECTION.INCOMING, label: "Incoming" },
  { value: INTERACTION_DIRECTION.OUTGOING, label: "Outgoing" },
];

// ============ ERROR MESSAGES ============
export const ERROR_MESSAGES = {
  FETCH_FAILED: "Failed to fetch data. Please try again.",
  FETCH_ONE_FAILED: "Failed to fetch details.",
  CREATE_FAILED: "Failed to create. Please try again.",
  UPDATE_FAILED: "Failed to update. Please try again.",
  DELETE_FAILED: "Failed to delete. Please try again.",
  NOT_FOUND: "Record not found.",
  CLIENT_NAME_REQUIRED: "Client name is required",
  LEAD_NAME_REQUIRED: "Lead name is required",
  PROJECT_TITLE_REQUIRED: "Project title is required",
};

// ============ SUCCESS MESSAGES ============
export const SUCCESS_MESSAGES = {
  CLIENT_CREATE_SUCCESS: "Client created successfully!",
  CLIENT_UPDATE_SUCCESS: "Client updated successfully!",
  CLIENT_DELETE_SUCCESS: "Client deleted successfully!",
  LEAD_CREATE_SUCCESS: "Lead created successfully!",
  LEAD_UPDATE_SUCCESS: "Lead updated successfully!",
  LEAD_CONVERT_SUCCESS: "Lead converted to client!",
  PROJECT_CREATE_SUCCESS: "Project created successfully!",
  PROJECT_UPDATE_SUCCESS: "Project updated successfully!",
  TASK_CREATE_SUCCESS: "Task created successfully!",
  TASK_UPDATE_SUCCESS: "Task updated successfully!",
  TASK_COMPLETE_SUCCESS: "Task completed!",
  APPOINTMENT_CREATE_SUCCESS: "Appointment scheduled!",
  INTERACTION_CREATE_SUCCESS: "Interaction logged!",
};

// ============ FILTERS ============
export const DEFAULT_CLIENT_FILTERS = {
  status: "all",
  stage: "all",
  type: "all",
  search: "",
  assignedTo: "all",
};

export const DEFAULT_LEAD_FILTERS = {
  status: "all",
  priority: "all",
  temperature: "all",
  type: "all",
  search: "",
  assignedTo: "all",
};

export const DEFAULT_PROJECT_FILTERS = {
  status: "all",
  stage: "all",
  type: "all",
  search: "",
  assignedTo: "all",
  month: "all",
};

export const DEFAULT_TASK_FILTERS = {
  status: "all",
  priority: "all",
  assignedTo: "all",
  search: "",
  dueDate: "all",
};
